import { PageBackground } from 'shared/components/PageBackground';
import { TemplateBody, TemplateContainer } from 'shared/templates/DefaultTemplate/styles';
import { IDefaultTemplateProps } from './types';

export const DefaultTemplate: React.FC<IDefaultTemplateProps> = ({ children }) => {
  return (
    <TemplateContainer>
      <PageBackground />
      <TemplateBody>{children}</TemplateBody>
    </TemplateContainer>
  );
};
